var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isNewDesignPage)?_c('NewHeaderItem'):_c('HeaderItem'),_c('v-main',{style:(_vm.isNewDesignPage ? 'background: initial' : '')},[_c('router-view')],1),(_vm.isNewDesignPage)?_c('NewFooterItem'):_c('FooterItem')],1)}
var staticRenderFns = []

export { render, staticRenderFns }